import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';
import '../styles/ExperienceViewModal.css';

const ExperienceViewModal = ({ show, onHide, onSwitchToEdit, experience }) => {
  if (!experience) return null;

  const cardStyle = experience.imageUrl ? 
    { backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.5)), url(${experience.imageUrl})` }
    : {};

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="experience-view-modal">
      <Modal.Body className="p-0">
        <div 
          className={`view-header ${!experience.imageUrl ? 'view-header-gradient' : ''}`}
          style={cardStyle}
        >
          <div className="header-content">
            <div className="header-top-info">
              {experience.year && <span className="year-badge-view">{experience.year}</span>}
              {experience.rating > 0 && (
                <div className="rating-display-view">
                  {[...Array(experience.rating)].map((_, i) => (
                    <FaStar key={i} size={18} color={'#ffc107'} />
                  ))}
                </div>
              )}
            </div>
            <h2 className="view-title">{experience.title}</h2>
          </div>
        </div>

        <div className="view-content">
          <div className="view-section">
            <h6>Purpose/Goal & Initial Mindset</h6>
            <p>{experience.purposeAndMindset || experience.whatICameFor}</p>
          </div>
          <div className="view-section">
            <h6>Main Highlights & Wins</h6>
            {Array.isArray(experience.keyMoments) ? (
              experience.keyMoments.length > 0 ? (
                <ul className="highlights-list">
                  {experience.keyMoments.map((moment, index) => (
                    <li key={index} className="highlight-item">{moment}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted">No highlights added</p>
              )
            ) : (
              <p>{experience.keyMoments}</p>
            )}
          </div>
          <div className="view-section">
            <h6>Personal Growth & Insights</h6>
            <p>{experience.personalGrowth}</p>
          </div>
          <div className="view-section">
            <h6>Useful Principles</h6>
            <p>{experience.usefulPrinciples}</p>
          </div>
          <div className="view-section">
            <h6>Regrets & Losses</h6>
            <p>{experience.regretsAndLosses || experience.regrets}</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="view-footer">
        <Button variant="secondary" onClick={onHide} className="me-auto">Close</Button>
        <Button variant="primary" onClick={onSwitchToEdit}>Edit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExperienceViewModal;
